import React, { useState } from 'react';
import { Button, Col, Form, Input, Row, } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import I18N from 'src/services/I18NService';
import { PromotionSearchParam } from 'src/entity/PromotionEntity';


interface IProps extends FormComponentProps<{}> {
  defaultQuery: Partial<PromotionSearchParam>,
  loading: boolean,
  onSearch: (query: Partial<PromotionSearchParam>) => void,
}

const PromotionSearchComp: React.FC<IProps> = (props) => {
  const { defaultQuery, loading, form, onSearch } = props;
  const { getFieldDecorator } = form;

  const [queryParam, setQueryParam] = useState(defaultQuery);

  const handleSearch = () => {
    const {name} = form.getFieldsValue();
    // 将表单输入项 => 接口需要的类型
    const query: Partial<PromotionSearchParam> = {
      name,
    };
    onSearch(query);
  }

  const handleReset = () => {
    const result = new PromotionSearchParam();
    setQueryParam(result);
    form.resetFields();
  }


  return (
    <Form className="mdd-search-form">
      <Row gutter={20} type="flex" align="middle" >
        <Col span={5}>
          <Form.Item label={I18N.get('common_name_desc')} style={{marginBottom: 0}}>
            {getFieldDecorator('name', {
              initialValue: queryParam.name,
            })(
              <Input
                autoComplete="off"
                placeholder={`${I18N.get('common_input')}${I18N.get('common_name_desc')}`}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={5}>
          <Button
            type="primary"
            onClick={handleSearch}
            loading={loading}
          >{I18N.get('common_search')}</Button>
          <Button
            onClick={handleReset}
            style={{marginLeft: 16}}
          >{I18N.get('common_clear')}</Button>
        </Col>
      </Row>
    </Form>
    
  )
}
const WrappedPromotionSearchComp = Form.create<IProps>()(PromotionSearchComp)
const PromotionSearch = React.memo(WrappedPromotionSearchComp);
export default PromotionSearch;


// WEBPACK FOOTER //
// ./src/components/views/Promotion/PromotionSearch.tsx